import { Switch, Route, Redirect } from "react-router";

import {
  Dashboard, ProgramRequestEdit, ProgramRequestList,
  InstitutionList, StartPage, RequestCodeBook, UserRole, AboutProgram, CreateGroupProgramRequest, NISOO2ProgramRequestList, StatementOfAccessibility, 
  NotificationList, NotificationAdministration, NotificationDetails, NotificationEdit
} from "../features";
import InstitutionDetails from "../features/Institution/InstitutionDetails";
import InstitutionEdit from "../features/Institution/InstitutionEdit";
import ProgramRequestDetails from "../features/ProgramRequest/ProgramRequestDetails";
import ProgramRequestMzo from "../features/ProgramRequestMzo/ProgramRequestMzo";
import { CreateUser } from "../features/UserRole/CreateUser";
import {
  programRequestNewRoute, dashboardRoute, institutionDetailsRoute, institutionEditRoute,
  programRequestListRoute, programRequestDetailsRoute, programRequestMzoRoute,
  institutionListRoute, programRequestEditRoute,
  userRoleRoute, startRoute, createUserRoute,
  codebookRouteProgramType, codebookRouteProgramName,
  codebookRouteLanguage, codebookRouteLanguageLevel,
  codebookRouteEducationSector, codebookRouteEducationSubSector,
  codebookRouteProfession, codebookRouteFormOfTeaching,
  codebookRouteEnrollmentCondition, codebookRouteKnowledgeCheck, aboutProgramRoute,
  createGroupProgramRequest, newProgramRequestListRoute, statementOfAcessibilityRoute, notificationRoute,
  notificationAdministrationRoute, notificationNewRoute, notificationEditRoute, notificationDetailRoute
} from "./routes";

export default function Routing() {
  return (
    <Switch>
      <Route exact path={startRoute()} component={StartPage} />
      <Route exact path={dashboardRoute()} component={Dashboard} />
      <Route exact path={institutionDetailsRoute()} component={InstitutionDetails} />
      <Route exact path={institutionEditRoute()} component={InstitutionEdit} />
      <Route exact path={programRequestNewRoute()} component={ProgramRequestEdit} />
      <Route exact path={programRequestEditRoute()} component={ProgramRequestEdit} />
      <Route exact path={programRequestListRoute()} component={ProgramRequestList} />
      <Route path={programRequestDetailsRoute()} component={ProgramRequestDetails} />
      <Route path={programRequestMzoRoute()} component={ProgramRequestMzo} />
      <Route exact path={institutionListRoute()} component={InstitutionList} />
      <Route exact path={codebookRouteProgramType()} component={RequestCodeBook} />
      <Route exact path={codebookRouteProgramName()} component={RequestCodeBook} />
      <Route exact path={codebookRouteLanguage()} component={RequestCodeBook} />
      <Route exact path={codebookRouteLanguageLevel()} component={RequestCodeBook} />
      <Route exact path={codebookRouteEducationSector()} component={RequestCodeBook} />
      <Route exact path={codebookRouteEducationSubSector()} component={RequestCodeBook} />
      <Route exact path={codebookRouteProfession()} component={RequestCodeBook} />
      <Route exact path={codebookRouteFormOfTeaching()} component={RequestCodeBook} />
      <Route exact path={codebookRouteEnrollmentCondition()} component={RequestCodeBook} />
      <Route exact path={codebookRouteKnowledgeCheck()} component={RequestCodeBook} />
      <Route exact path={userRoleRoute()} component={UserRole} />
      <Route exact path={createUserRoute()} component={CreateUser} />
      <Route exact path={aboutProgramRoute()} component={AboutProgram} />
      <Route exact path={createGroupProgramRequest()} component={CreateGroupProgramRequest} />
      <Route exact path={newProgramRequestListRoute()} component={NISOO2ProgramRequestList}/>
      <Route exact path={statementOfAcessibilityRoute} component={StatementOfAccessibility}/>
      <Route exact path={notificationRoute()} component={NotificationList}/>
      <Route exact path={notificationAdministrationRoute()} component={NotificationAdministration}/>
      <Route exact path={notificationNewRoute()} component={NotificationEdit}/>
      <Route exact path={notificationEditRoute()} component={NotificationEdit}/>
      <Route exact path={notificationDetailRoute()} component={NotificationDetails}/>

      <Route exact path="/">
        <Redirect to={startRoute()} />
      </Route>

    </Switch>
  );
}
